<template>
    <div class="page-order page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">订单汇总</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
                            <el-breadcrumb-item>订单汇总</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
<!--                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="order_number" label="订单号：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.order_number" size="small" placeholder="请输入订单号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="desk_name" label="店铺名称：">
                            <el-input v-model="form_search.desk_name" size="small" placeholder="请输入店铺名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="预定时间：">
                            <el-date-picker
                                    size="small"
                                    clearable
                                    v-model="create_range"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>-->
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <el-table-column prop="finish_date" align="center" label="配送时间" min-width="200">
                                <!--<template slot-scope="scope">
                                    <span>{{scope.row.finish_date}}{{scope.row.order_type_name}}</span>
                                </template>-->
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.order_type">{{scope.row.finish_date}}{{scope.row.order_type_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="paid_amount" align="center" label="总金额" min-width="160">
                            </el-table-column>
                            <el-table-column prop="product_count" align="center" label="商品数量" min-width="120">
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="340" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-m" type="primary" size="mini" @click="goodsDetail(scope.row.finish_date,scope.row.order_type)">商品汇总</el-button>
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="printAll(scope.row.finish_date,scope.row.order_type)">打印后台单</el-button>
                                    <el-button class="option-btn btn-bd-o" type="primary" size="mini" @click="printOther(scope.row.finish_date,scope.row.order_type)">打印后台单(格式2)</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
                <el-dialog class="dialog-export activity-dialog" :title="dlg_goods.title" :visible.sync="dlg_goods.visible" width="540px" :close-on-click-modal="false">
                    <el-table ref="multipleTable" :data="dlg_goods.table_data.list" v-loading="dlg_goods.table_data.loading" max-height="600px" tooltip-effect="dark" style="width: 100%;text-align: center;">
                        <el-table-column prop="product_name" align="center" label="商品名称" min-width="180">
                            <template slot-scope="scope">
                                <my-textEllipsis v-if="is_refresh" :content="scope.row.product_name"></my-textEllipsis>
                            </template>
                        </el-table-column>
                        <!--<el-table-column prop="product_intro" align="center" label="商品简介" min-width="160">
                            <template slot-scope="scope">
                                <my-textEllipsis v-if="is_refresh" :content="scope.row.product_intro"></my-textEllipsis>
                            </template>
                        </el-table-column>-->
                        <el-table-column prop="product_count" align="center" label="商品数量" min-width="120">
                            <template slot-scope="scope">
                                <span>{{scope.row.product_count}}{{scope.row.product_unit}}</span>
                            </template>
                        </el-table-column>
                        <!--<el-table-column prop="sale_total_amount" align="center" label="商品总价" min-width="120">
                        </el-table-column>
                        <el-table-column prop="image_url" align="center" label="商品图片" min-width="80">
                            <template slot-scope="scope">
                                <img class="cursor" :src="baseUrl + scope.row.product_image_url_s" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.product_image_url;dlg_preview.visible = true;" title="点击查看" />
                            </template>
                        </el-table-column>-->
                    </el-table>
                </el-dialog>
                <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
                    <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                baseUrl:this.$client.IMG_URL,
                body_loading:false,
                is_refresh: true,
                //create_range:'',
               /* form_search:{
                    order_number:'',
                    desk_name:"",
                    start_appointment_date:'',
                    end_appointment_date:''
                },*/
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 10,
                        total: 130
                    }
                },
                dlg_goods:{
                    title:'商品汇总详情',
                    visible:false,
                    table_data:{
                        loading: false,
                        list:[]
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '已完成列表';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = {};
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/orderstatis/daily', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            printAll(query_date,order_type){
                var _this = this;
                var params={
                    query_date:query_date,
                    order_type:order_type
                };
                this.$client.post('/adminapi/orderstatis/printfdaily', params, function(res,message){
                    _this.$message(message);
                },function(res){

                });
            },
            printOther(query_date,order_type){
                var _this = this;
                var params={
                    query_date:query_date,
                    order_type:order_type
                };
                this.$client.post('/adminapi/orderstatis/printfdaily2', params, function(res,message){
                    _this.$message(message);
                },function(res){

                });
            },
            goodsDetail(query_date,order_type){
                var _this = this;
                var params={
                    query_date:query_date,
                    order_type:order_type
                };
                this.dlg_goods.table_data.loading = true;
                this.$client.post('/adminapi/orderstatis/dailydetail', params, function(res,message){
                    _this.dlg_goods.table_data.list = res;
                    _this.dlg_goods.visible = true;
                    _this.dlg_goods.table_data.loading = false;
                },function(res){
                    _this.dlg_goods.table_data.loading = false;
                });
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            },
            /*create_range(newVal){
                //console.log(newVal);
                if(newVal == null){
                    this.form_search.start_appointment_date = '';
                    this.form_search.end_appointment_date = '';
                }else{
                    this.form_search.start_appointment_date = newVal[0];
                    this.form_search.end_appointment_date = newVal[1];
                }
            }*/
        }
    }
</script>
<style>

</style>
<style scoped>
    .status-2{
        color: #04B365;
    }
    .status-1{
        color: #F31A5C;
    }
    .status-0{
        color: #F27918;
    }
</style>